import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { Req } from 'src/environments/environment';
import { LoadingController, ModalController, NavController } from '@ionic/angular';
import { UserService } from '../user.service';
import { Commerce } from 'src/environments/environment';
import { loadOpt } from 'src/environments/environment';
import { Globals } from '../globals';
import { AdressPage } from '../adress/adress.page';
import { Storage } from '@ionic/storage-angular';
import { CartService } from '../cart.service';

declare var google;
@Component({
  selector: 'app-tab1',
  templateUrl: 'tab1.page.html',
  styleUrls: ['tab1.page.scss']
})

export class Tab1Page implements OnInit {
  commerce={} as Commerce
  commerces: any[] = [];
  commerces1: any = [];
  notifications: any[] = [];
  autocompleteItems: any[];
  GoogleAutocomplete: any;
  placesService: any;
  lat: string = '';
  lng: string = '';
  total_final_commerces: number;
  //tipology: string;
  direccionAnterior: string;

  // Andy (storage)
  address;
  postal_code;
  number;
  door;
  tipology;


  constructor(
    public modal: ModalController,
    public user: UserService,
    public rest: RestService,
    private nav: NavController,
    private stop:LoadingController,
    public load: LoadingController,
    public global: Globals,
    public storage: Storage,
    public service: CartService,
  ) {
    this.storage.create();
    this.GoogleAutocomplete = new google.maps.places.AutocompleteService();
    this.placesService = new google.maps.places.PlacesService(document.createElement('div'));
    this.autocompleteItems = [];
    /* localStorage.removeItem('cart');
    localStorage.removeItem('commerce');
    localStorage.removeItem('TotalPrice');
    this.service.total = 0;
    this.service.cart = [];  */ 
    this.global.param_commerce = localStorage.getItem('tipology')
    this.obtenerEstablecimientosCercanos();

  }
  
 async ngOnInit(){
    // localStorage.setItem('cart', '');
    // localStorage.setItem('TotalPrice', '');
    // localStorage.setItem('commerce', '');
    
    
    localStorage.removeItem('cart');
    localStorage.removeItem('commerce');
    localStorage.removeItem('TotalPrice');
    this.service.total = 0;
    this.service.cart = []; 
    this.address = await this.storage.get('address');
    this.postal_code = await this.storage.get('postal_code');
    this.number = await this.storage.get('number');
    this.door = await this.storage.get('door');
    this.tipology = await this.storage.get('tipology');
    /* console.log(this.address)
    console.log(this.postal_code)
    console.log(this.number)
    console.log(this.door)
    console.log(this.tipology) */


      if(this.user.isLoggedIn){
        this.rest.getAdress().subscribe(data=>{
          this.user.adressesUser=data['data']
        })
      }
      this.ObtenerNotificaciones();
      this.obtenerEstablecimientosCercanos();
 }


  async obtenerEstablecimientosCercanos(){
    localStorage.setItem('cart', '');
    localStorage.setItem('TotalPrice', '');
    localStorage.setItem('commerce', '');
    const loading = await this.stop.create(loadOpt);
    await loading.present();
    /* console.log('Dirección: ' + this.address)
    console.log('POSTAL_CODE: ' + this.postal_code) */
    this.rest.getEstablecimientosCercanos(this.address, this.global.param_commerce, this.postal_code, this.global.lat, this.global.lng)
    //this.rest.getEstablecimientosCercanos(this.global.address_map, this.global.param_commerce, this.global.cp_map, this.global.lat, this.global.lng)
    .toPromise().then((data: Req) => {
      this.commerces = data.data
      this.total_final_commerces = this.commerces.length;
      loading.dismiss();

    });
    // .subscribe((data: Req) => this.commerces = data.data);
    }
    
  obtenerEstablecimientos(){
    this.rest.ObtenerEstablecimientos().subscribe(
      (data: Req) => this.commerces = data.data);
  }

  Commerce(commerce){
    /* localStorage.removeItem('cart');
    localStorage.removeItem('commerce');
    localStorage.removeItem('TotalPrice');
    this.service.total = 0; 
    this.service.cart = [];  */ 
    this.nav.navigateForward('/commerce/' + commerce.id);
  }

  GotoNotifications(){
    this.nav.navigateForward('/notificaciones');
  }

  GotoLogin(){
    this.nav.navigateForward('/login');
  }

 async enviarDireccion(){
    this.user.adressesUser.forEach(e => {
      let calle = e.address + ' ' + e.number
      if (calle == this.address) {
        this.postal_code = e.postal_code
        this.lat = e.lat
        this.lng = e.lng
      }
    });
    this.direccionAnterior = this.address;
    const loading = await this.stop.create(loadOpt);
    await loading.present();

    this.rest.getEstablecimientosCercanos(this.address, this.global.param_commerce, this.postal_code, this.lat, this.lng).subscribe(data=>{
      this.commerces=data['data']
    loading.dismiss()
    })
    }

    goToTab3(){
      this.nav.navigateForward('/tabs/tab3');
    }
  
  ObtenerNotificaciones(){
    this.rest.ObtenerNotificaciones().subscribe((data) => {
      this.notifications = data['data'];
    });
    setTimeout(() => this.ObtenerNotificaciones(), 60000);
  }

clearSugerencias(){
  this.autocompleteItems = [];
}

goToWorlds(){
  this.nav.navigateRoot('two-worlds');
}

goToMap(){
  this.nav.navigateRoot('');
}

async presentModal() {
  const modal = await this.modal.create(
    { component: AdressPage });

  await modal.present();
}

async doRefresh(event) {
  const loading = await this.load.create({
    message: 'Cargando comercios...',
  });

  loading.present();
  setTimeout(() => {
      //this.ObtenerNotificaciones()
      this.obtenerEstablecimientosCercanos();    
      loading.dismiss();
      event.target.complete();
      this.direccionAnterior = this.address;
    }, 1000);
  }
}
